import React from "react";

export default function IntroBanner() {
  return (
    <div className="intro-banner">
      <div className="intro-inner">
        <span className="intro-example">accessingh</span>
        <span className="intro-example">afghanistanbul</span>
        <span className="intro-example">anonymouse</span>
        <span className="intro-example">genevada</span>
      </div>
      <p className="intro-text">
        Two real words, smashed into one ridiculous new word. Vote on which blend is funnier — the crowd decides the funniest of all time.
      </p>
    </div>
  );
}
